import { render, staticRenderFns } from "./confirmation-certificate.vue?vue&type=template&id=6b34b90e&scoped=true&lang=pug"
import script from "./confirmation-certificate.vue?vue&type=script&lang=ts"
export * from "./confirmation-certificate.vue?vue&type=script&lang=ts"
import style0 from "./confirmation-certificate.vue?vue&type=style&index=0&id=6b34b90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b34b90e",
  null
  
)

export default component.exports